<script>
    export let displayTab = "";
    export let currentTab = "";
    export let tabUrl = "";
    export let tabClass = "";
    export let isHidden = false;
    export let clickTabFunc = () => {};

    $: defaultTabClass = `tab tab-bordered w-auto ${currentTab == tabUrl ? "tab-active" : ""}`;
</script>

{#if !isHidden}
    <p
        class={`${defaultTabClass} ${tabClass}`}
        on:click|preventDefault={clickTabFunc}
    >
        {displayTab}
        <slot />
    </p>
{/if}

<style>
    .tab {
        padding: 0 0.5rem !important;
    }

    .tab-active {
        background-color: hsl(var(--s) / var(--tw-bg-opacity));
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        color: white;
    }
</style>
